import { fallback, http } from 'viem';

export const POLYGON_CHAIN_ID = 137;
export const POLYGON_RPC_URLS = [
  'https://polygon-bor-rpc.publicnode.com',
  'https://polygon.drpc.org',
];

// Validate each endpoint before trusting its data. No wallet/cloud proxy is involved.
export function createPolygonTransport(urls = POLYGON_RPC_URLS) {
  return fallback(urls.map(url => options => {
    const transport = http(url, { timeout: 8000, retryCount: 0 })(options);
    let validation;
    const validate = () => {
      if (!validation) {
        validation = transport.request({ method: 'eth_chainId' }).then(id => {
          if (Number(BigInt(id)) !== POLYGON_CHAIN_ID) throw new Error('RPC is not Polygon (137)');
          return id;
        }).catch(error => { validation = null; throw error; });
      }
      return validation;
    };
    return {
      ...transport,
      request: async args => {
        const id = await validate();
        return args.method === 'eth_chainId' ? id : transport.request(args);
      },
    };
  }), { retryCount: 0 });
}
